import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';

const homeStyles = {
  root: {
    textAlign: 'center',
    width: '600px',
    margin: 'auto',
    '& .pageDescrip': {
      textAlign: 'left',
      paddingLeft: '100px',
    },
  },
};

class AllevaRepHome extends Component {
  constructor(props) {
    super(props);

    this.state = { redirect: '' };
  }

  handleViewDemosClick() {
    this.setState({ redirect: 'demos' });
  }

  handleLaunchDemoClick() {
    // redirect to the launcher page
    this.setState({ redirect: 'launchDemo' });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} push />;
    }
    const { classes, prefName, lastName } = this.props;
    return (
      <div className={classes.root}>
        <h3>
          This is the default page for {prefName} {lastName}
        </h3>
        <div className={classes.root + ' pageDescrip'}>
          Because {prefName} is an Aleva Rep, this page should provide ways to
          <ul>
            <li>Generate and view Demos</li>
          </ul>
        </div>
        <hr />
        <div>
          <button onClick={() => this.handleLaunchDemoClick()}>Launch a new Demo</button>
          <br />
          <button onClick={() => this.handleViewDemosClick()}>View Demos</button>
          <br />\
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ prefName: state.userInfo.prefName, lastName: state.userInfo.lastName });

export default connect(mapStateToProps)(withStyles(homeStyles)(AllevaRepHome));
